import isEmpty from "lodash/isEmpty";

import { GroupClassRegistrationModalTestID } from "@/constants/TestID";
import { Avatar, Text } from "@/ui/core";
import { Box, HStack, VStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface TherapistAssignmentHeaderProps extends ViewWithTestID {
  isSupportUser: boolean;
  patientFirstName: string;
  therapistName?: string;
  therapistUserId?: string;
}

const TherapistAssignmentHeader = ({
  isSupportUser,
  patientFirstName,
  testID,
  therapistName,
  therapistUserId,
}: TherapistAssignmentHeaderProps) => {
  const headerTestID = joinTestIDs(
    testID,
    GroupClassRegistrationModalTestID.therapistHeader,
  );
  const prefix = isSupportUser ? `${patientFirstName}'s` : "Your";
  const titleText = `${prefix} therapist has assigned your first skills group`;
  const hasTherapist = !isEmpty(therapistUserId);

  return (
    <VStack gap={16} testID={headerTestID}>
      <HStack alignItems="center" gap={12}>
        {hasTherapist ? (
          <Avatar
            size="md"
            testID={joinTestIDs(
              testID,
              GroupClassRegistrationModalTestID.therapistHeaderAvatar,
            )}
            userId={therapistUserId}
            userName={therapistName ?? ""}
            userType="provider"
          />
        ) : null}
        <Box flex={1} flexShrink={1}>
          <Text
            testID={joinTestIDs(
              testID,
              GroupClassRegistrationModalTestID.therapistHeaderTitle,
            )}
            variant="h5"
          >
            {titleText}
          </Text>
        </Box>
      </HStack>
      <Text
        testID={joinTestIDs(
          testID,
          GroupClassRegistrationModalTestID.therapistHeaderDescription,
        )}
        variant="body"
      >
        Groups are an essential and critical part of treatment with Equip that
        complement your provider sessions. Group assignments are based
        specifically on your diagnosis and treatment plan.
      </Text>
    </VStack>
  );
};
export type { TherapistAssignmentHeaderProps };
export default TherapistAssignmentHeader;
